import { mapColor } from '@bubble-ui/particle-icon-colors';
import { useDesignContext } from '@klarna/designtokens';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
export var navigationActivatableDefaultStyleSheetGetter = _ref => {
  var {
    color,
    isActive,
    designVersion,
    colorToken,
    colorTokenArgs
  } = _ref;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var designContext = useDesignContext(defaultColorVariables);
  return {
    pathStyle: {
      fill: colorToken ? designContext.get(colorToken, colorTokenArgs).toRGBA() : mapColor(color, color || (isActive ? designContext.get('colors/text/default').toRGBA() : designContext.get('colors/text/neutral').toRGBA()), designVersion)
    }
  };
};
//# sourceMappingURL=navigationActivatable.js.map